module.exports = __webpack_public_path__ + "src/assets/img/favicon.2b1bd7df.svg";